import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['svgImage'];

  static values = { filename: String };

  // jsPDF + svg2pdf.js are large and only needed for this admin-only export
  // action, so they're code-split into their own chunk instead of bundled
  // into every entrypoint that loads the shared controllers index.
  async download(event) {
    // Without this the anchor's default click also fires and, combined with
    // its download attribute, saves the page HTML as a second file.
    event.preventDefault();

    const [{ jsPDF }] = await Promise.all([
      import('jspdf'),
      import('svg2pdf.js'),
    ]);

    // eslint-disable-next-line new-cap -- jsPDF is the library's actual export name
    const doc = new jsPDF({
      unit: 'mm',
      format: [160, 160],
    });
    const element = this.svgImageTarget.querySelector('svg');

    doc
      .svg(element, {
        x: 0,
        y: 0,
      })
      .then(() => {
        // download the created pdf
        doc.save(this.filenameValue);
      });
  }
}
